var _excluded = ["borderColor", "wrapperClassName", "contentWidth", "trigger", "children", "disablePortal", "showArrow", "placement", "contentClassName", "disabled", "onClose", "onOpen", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Popper from "@mui/base/PopperUnstyled";
import { Transition } from "react-transition-group";
import FocusLock from "react-focus-lock";
import uuid from "uuid/v4";
import classNames from "classnames";
import PlainButton from "../elements/plain-button";
import OutsideClick from "../elements/outside-click";
import useFocus from "../../hooks/use-focus";

var Popover2 = function Popover2(_ref) {
  var borderColor = _ref.borderColor,
      wrapperClassName = _ref.wrapperClassName,
      contentWidth = _ref.contentWidth,
      trigger = _ref.trigger,
      children = _ref.children,
      disablePortal = _ref.disablePortal,
      _ref$showArrow = _ref.showArrow,
      showArrow = _ref$showArrow === void 0 ? false : _ref$showArrow,
      placement = _ref.placement,
      contentClassName = _ref.contentClassName,
      disabled = _ref.disabled,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {} : _ref$onClose,
      _ref$onOpen = _ref.onOpen,
      onOpen = _ref$onOpen === void 0 ? function () {} : _ref$onOpen,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFocus = useFocus(),
      _useFocus2 = _slicedToArray(_useFocus, 2),
      anchorRef = _useFocus2[0],
      setAnchorFocus = _useFocus2[1];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      arrowRef = _useState2[0],
      setArrow = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      anchorEl = _useState4[0],
      setAnchorEl = _useState4[1];

  var is_open = Boolean(anchorEl);
  var uid = useRef(uuid());
  var id = is_open ? uid.current : undefined;
  var modifiers = [{
    name: "arrow",
    enabled: showArrow,
    options: {
      element: arrowRef
    }
  }, {
    name: "preventOverflow",
    enabled: true,
    options: {
      altAxis: true,
      padding: 16
    }
  }];

  var handleOpen = function handleOpen() {
    setAnchorEl(anchorRef.current);
    onOpen();
  };

  var handleClose = function handleClose() {
    var returnFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    setAnchorEl(null);
    onClose();

    if (returnFocus) {
      setTimeout(function () {
        setAnchorFocus();
      }, 0);
    }
  };

  var onOutsideClick = function onOutsideClick(event) {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    handleClose(false);
  };

  useEffect(function () {
    var closeOnEsc = function closeOnEsc(e) {
      if (is_open && e.key === "Escape") {
        handleClose();
      }
    };

    document.body.addEventListener("keydown", closeOnEsc, {
      capture: true
    });
    return function () {
      document.body.removeEventListener("keydown", closeOnEsc, {
        capture: true
      });
    };
  }, [is_open, handleClose]);
  var triggerEl = typeof trigger === "function" ? /*#__PURE__*/React.cloneElement(trigger({
    is_open: is_open,
    openPopover: handleOpen,
    closePopover: handleClose,
    togglePopover: is_open ? handleClose : handleOpen
  }), {
    ref: anchorRef,
    "aria-describedby": id
  }) : /*#__PURE__*/React.createElement(PlainButton, {
    ref: anchorRef,
    "aria-describedby": id,
    onClick: is_open ? handleClose : handleOpen
  }, trigger);
  return /*#__PURE__*/React.createElement(React.Fragment, null, triggerEl, /*#__PURE__*/React.createElement(Popper, _extends({
    className: "et--popover2--outer ".concat(className),
    modifiers: modifiers,
    id: id,
    open: is_open,
    anchorEl: anchorEl,
    disablePortal: disablePortal,
    placement: placement
  }, rest), function (_ref2) {
    var placement = _ref2.placement;
    return /*#__PURE__*/React.createElement(React.Fragment, null, showArrow ? /*#__PURE__*/React.createElement("span", {
      className: "et--popover2--arrow " + placement,
      ref: function ref(e) {
        return setArrow(e);
      }
    }) : null, /*#__PURE__*/React.createElement(OutsideClick, {
      onOutsideClick: onOutsideClick
    }, /*#__PURE__*/React.createElement("div", {
      className: wrapperClassName,
      "data-no-focus-lock": true
    }, /*#__PURE__*/React.createElement(Transition, {
      in: is_open,
      timeout: 200,
      appear: true,
      unmountOnExit: true,
      mountOnEnter: true
    }, function (state) {
      return /*#__PURE__*/React.createElement(FocusLock, {
        focusOptions: {
          preventScroll: true
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames("et--popover2", contentClassName, state),
        style: {
          width: contentWidth
        }
      }, typeof children === "function" ? children({
        closePopover: handleClose
      }) : children));
    }))));
  }));
};

Popover2.propTypes = {
  disabled: PropTypes.bool,
  borderColor: PropTypes.string,
  children: PropTypes.any,
  contentClassName: PropTypes.string,
  contentWidth: PropTypes.number,
  disablePortal: PropTypes.bool,
  placement: PropTypes.string,
  showArrow: PropTypes.bool,
  trigger: PropTypes.any,
  wrapperClassName: PropTypes.any,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  className: PropTypes.string
};
export default Popover2;